import * as React from "react";
import Skeleton from "@mui/material/Skeleton";
import { Box, Stack } from "@mui/material";

export const menuGridSx = {
  display: "grid",
  gap: 2,
  gridTemplateColumns: {
    xs: "minmax(0, 1fr)",
    sm: "repeat(2, minmax(0, 1fr))",
    lg: "repeat(3, minmax(0, 1fr))",
  },
};

// List-style card skeleton matching ItemCard (text left, thumbnail right).
export function ItemCardSkeleton() {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        p: 1.5,
        minHeight: 136,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
      }}
    >
      <Stack flex={1} spacing={0.5}>
        <Skeleton variant="text" width="70%" height={28} />
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="85%" />
        <Skeleton variant="text" width={56} height={28} />
      </Stack>
      <Skeleton variant="rounded" width={96} height={96} sx={{ flexShrink: 0 }} />
    </Stack>
  );
}

export default function MenuSkelton() {
  return (
    <Box sx={menuGridSx} aria-busy="true" aria-label="Loading menu">
      {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
        <ItemCardSkeleton key={i} />
      ))}
    </Box>
  );
}
